import { render } from "./PageAddWizard.vue?vue&type=template&id=710b3c1c"
import script from "./PageAddWizard.vue?vue&type=script&lang=js"
export * from "./PageAddWizard.vue?vue&type=script&lang=js"

import "./PageAddWizard.vue?vue&type=style&index=0&id=710b3c1c&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__